import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

const RenewableChoiceField = ({ setFieldValue, setRenewableChoice }) => {

  const handleChange = (event) => {
    setFieldValue('renewableChoice', event.target.value);
    setRenewableChoice(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Type de renouvellement</FormLabel>
      <RadioGroup
        row
        name="renewableChoice"
        defaultValue="recurring" // default value is recurring (not unique)
        onChange={handleChange}
      >
        <FormControlLabel value="recurring" control={<Radio />} label="Renouvelable à l'année" />
        <FormControlLabel value="unique" control={<Radio />} label="Unique" />
      </RadioGroup>
    </FormControl>
  );
};

export default RenewableChoiceField;
